import { Injectable, inject, computed } from '@angular/core';
import { InvitationHttpService } from '@shared/services/invitations/invitation-http.service';
import { Invitation } from '@shared/interfaces';
import { ToastService, Toast } from '@shared/components/toast';
import { catchError, filter, of, tap } from 'rxjs';
import {
  rxResource,
  takeUntilDestroyed,
  toObservable,
} from '@angular/core/rxjs-interop';

@Injectable()
export class InvitationResourceService {
  private readonly _invitationHttp = inject(InvitationHttpService);
  private readonly toast = inject(ToastService);

  private readonly _resourceDefaultValue: Invitation[] = [];

  private readonly _errorToast: Toast = {
    type: 'error',
    message: 'Error invitations',
  };

  private readonly _resource = rxResource({
    defaultValue: this._resourceDefaultValue,
    stream: () =>
      this._invitationHttp
        .getInvitations()
        .pipe(catchError(() => of(this._resourceDefaultValue))),
  });

  public readonly invitations = computed(() => this._resource.value());

  public readonly isLoading = this._resource.isLoading;

  public resetResource() {
    this._resource.reload();
  }

  constructor() {
    toObservable(this._resource.error)
      .pipe(
        filter((error) => !!error),
        tap(() => {
          this.toast.show(this._errorToast);
        }),
        takeUntilDestroyed(),
      )
      .subscribe();
  }
}
